import React from 'react';
import { PlusIcon } from './Icons';
import ConversationItem from './ConversationItem';

interface Conversation {
  id: string;
  name: string;
  lastMessage?: string;
  updatedAt: string | Date;
}

interface ConversationListProps {
  conversations: Conversation[];
  activeConversationId?: string;
  onSelectConversation: (id: string) => void;
  onNewChat: () => void;
  onImportFromDevice?: () => void;
  onRenameConversation?: (id: string, newName: string) => void;
  onDeleteConversation?: (id: string) => void;
}

const ConversationList: React.FC<ConversationListProps> = ({
  conversations,
  activeConversationId,
  onSelectConversation,
  onNewChat,
  onImportFromDevice,
  onRenameConversation,
  onDeleteConversation,
}) => {
  const containerStyle: React.CSSProperties = {
    width: '220px',
    height: '100%',
    backgroundColor: '#1F313A',
    borderRight: '1px solid rgba(255,255,255,0.1)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  };

  const headerStyle: React.CSSProperties = {
    padding: '12px',
    borderBottom: '1px solid rgba(255,255,255,0.1)',
  };

  const importLinkStyle: React.CSSProperties = {
    display: 'block',
    marginTop: '8px',
    padding: '6px 0',
    background: 'none',
    border: 'none',
    color: '#8899A6',
    fontSize: '11px',
    cursor: 'pointer',
    textDecoration: 'underline',
  };

  const newChatButtonStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    width: '100%',
    padding: '10px 12px',
    backgroundColor: '#33AA40',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background-color 0.15s ease',
  };

  const listStyle: React.CSSProperties = {
    flex: 1,
    overflowY: 'auto',
    padding: '8px',
  };

  const emptyStyle: React.CSSProperties = {
    padding: '20px 12px',
    textAlign: 'center',
    fontSize: '12px',
    color: '#8899A6',
  };

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <button
          style={newChatButtonStyle}
          onClick={onNewChat}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLElement).style.backgroundColor = '#2E9638';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLElement).style.backgroundColor = '#33AA40';
          }}
        >
          <PlusIcon size={16} color="#ffffff" />
          New Chat
        </button>
        {onImportFromDevice && (
          <button
            type="button"
            style={importLinkStyle}
            onClick={onImportFromDevice}
            title="Import previous conversations from this browser"
          >
            Import from this device
          </button>
        )}
      </div>
      <div style={listStyle}>
        {conversations.length === 0 ? (
          <div style={emptyStyle}>No conversations yet. Start a new chat!</div>
        ) : (
          conversations.map((conv) => (
            <ConversationItem
              key={conv.id}
              conversation={conv}
              isActive={conv.id === activeConversationId}
              onClick={() => onSelectConversation(conv.id)}
              onRename={onRenameConversation}
              onDelete={onDeleteConversation}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default ConversationList;
